const initialState = {
    fields: [],
    isReadingFields: false,
    fieldBeingUpdated: null
}

export default initialState;
